export default {
  SET_USERS(state, data) {
    state.users = data
  },
  SET_USER(state, data) {
    state.user = data
  },
  SET_ONE_USER(state, data) {
    const userIndex = state.users.results.findIndex(u => u.id === data.id)
    state.users.results.splice(userIndex, 1, data)
  },

  SET_ROLES(state, data) {
    state.roles = data
  },

  SET_ONE_ROLE(state, data) {
    const roleIndex = state.roles.results.findIndex(u => u.id === data.id)
    state.roles.results.splice(roleIndex, 1, data)
  },

  SET_GROUPS(state, data) {
    state.groups = data
  },
  SET_USER_PHONES(state, data) {
    state.user_phones = data
  },

  SET_USERS_ASYNC(state, data) {
    state.users_list = {
      ...data,
      results: [...state.users_list.results, ...data.results],
    }
  },
}
